var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"detail-container"},[_c('detail-header'),_c('detail-base-info'),_c('detail-things-like'),_c('question-list'),_c('photo-list')],1)}
var staticRenderFns = []

export { render, staticRenderFns }